import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function (props) {
	return (
		<FormControl className={props.className} fullWidth variant="outlined">
			<InputLabel htmlFor="outlined-adornment-amount">{props.label}</InputLabel>
			<OutlinedInput
				disabled={props.disabled}
				className={props.valueClassName}
				error={props.error}
				id="outlined-adornment-amount"
				labelWidth={60}
				onChange={props.onChange}
				startAdornment={props.startAdornment}
				type={props.type}
				value={props.value}
			/>
			<FormHelperText id="text-red">{props.error}</FormHelperText>
		</FormControl>
	);
});
